/* eslint-disable import/prefer-default-export */
import { ShadowType } from '@src/endpoints/services/graphQueryMgr.service'
import { ColumnProps, ColumnType } from '@src/components/data.grid'
import type { ShadowAccountItem } from '@src/redux/reducers/external.lists/default.state'
import { Routes } from '@src/constants/routes'
import type { ShadowAccountColumnsOptions } from '../models'

export const getShadowKnownAccountColumns = ({
  goToSearchResult
}: ShadowAccountColumnsOptions): ColumnProps<ShadowAccountItem>[] => [
  {
    field: 'shadow_account_id',
    title: 'Shadow Source'
  },
  {
    field: 'account_name',
    title: 'Target Source'
  },
  {
    field: 'resources_available',
    title: 'Resources Accessible',
    onClick: (item, column, history) => {
      const query = `user with-attribute accountid ${item.shadow_account_id} with-access any with-attribute accountid ${item.account_id}`
      goToSearchResult(query)
      history?.push(Routes?.pages?.searchResult?.path)
    }
  }
]

export const getShadowAccountColumns = (
  options: ShadowAccountColumnsOptions
): ColumnProps<ShadowAccountItem>[] => [
  { type: ColumnType.selector },
  {
    field: 'name',
    title: 'Shadow Source Name',
    hide: options?.selectedTab !== ShadowType.SHADOW_UNKNOWN_ACCOUNT
  },
  ...getShadowKnownAccountColumns(options)
]
